import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import {
  MonedasConstant,
  OrigenesContabilidadConstant,
  DhContabilidadConstant
} from 'constants/index'

import { KeyEventUtil } from 'utils'

const MonedaFormGroup = ({
  vDh,
  vOrigen,
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  updateStore,
  rowIndex
}) => {
  const [monedasOptions, setMonedasOptions] = React.useState([])

  React.useEffect(() => {
    if (vOrigen === OrigenesContabilidadConstant.VENTAS) {
      setMonedasOptions(
        MonedasConstant.__array.map((x, k) => (
          <option key={k} value={x.id}>
            {x.nombre}
          </option>
        ))
      )
    } else {
      setMonedasOptions(
        MonedasConstant.__array.map((x, k) => (
          <option key={k} value={x.id}>
            {x.nombre}
          </option>
        ))
      )
    }
  }, [vOrigen])

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(
        vDh === DhContabilidadConstant.HABER
          ? `input-det-importeHaber-${rowIndex}`
          : `input-det-importeDebe-${rowIndex}`,
        e
      )
    },
    [rowIndex, vDh]
  )

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      updateStore()
    },
    [handleChange, updateStore]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select
              {...field}
              id={`select-det-moneda-${rowIndex}`}
              isInvalid={iTouched && iError}
              disabled
              onKeyDown={onKeyDown}
              onChange={onChange}
            >
              {monedasOptions}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
